export const PaymentOptions = [
  "/assets/icons/visa.svg",
  "/assets/icons/master_card.svg",
  "/assets/icons/amex.svg",
  "/assets/icons/paypal.svg",
  "/assets/icons/mada.svg",
];
